import { useBusinessAuthContext } from "./useBusinessAuthContext";
import { Link,useNavigate } from "react-router-dom";
import API_URL from "../../api/API";

export const useBusinessLogout = () => {

    const { dispatch } = useBusinessAuthContext();
    const navigate = useNavigate();

    
    const logout = async () => {     

        /* Call this from frontend before clearing localStorage */
        const business = JSON.parse(localStorage.getItem("business"));
        if (business?.token && business?.sessionId) {
            await fetch(API_URL.BUSINESS_LOGOUT, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${business.token}`,
                "x-session-id": business.sessionId,
                "x-frontend-url": window.location.pathname,
            },
            }).catch(() => {});
        }
   

        //remove user from local storage
        //localStorage.removeItem('business'); - added in dispatch
        //dispatch logout action
        dispatch({type: 'BUSINESS_LOGOUT'});
        navigate('/business/login');
        
    }
    return { logout };
}